module.exports = __webpack_public_path__ + "static/media/r-right.47dcce16.svg";